/**
 * Created by danielg on 5/5/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var queueModel;
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;
    var logger;
    var ringList = [];
    var waitForAssignmentTimeout = 20000;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var ringService = BaseController.extend(function lpRingService(options) {
        ringList = [];
        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        if (options) {
            _setModel(options.model);
            if(_.isNumber(options.waitForAssignmentTimeout)) {
                waitForAssignmentTimeout = options.waitForAssignmentTimeout;
            }
        }
        if (queueModel) {
            // Set binds here
            queueModel.bind("amsService.socketState", this.socketClose,this);
            queueModel.bind("amsService.socketState", this.socketConnected,this);
        }

        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onRingUpdate, this.onRingUpdate.bind(this));
        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onRoutingUpdate, this.onRoutingNotification.bind(this));


    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////

    ringService.prototype.applicationType = 'RingService';

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    /**
     * Takes the first conversation from the open conversations queue
     * @param request - The request, containing optional success/error/context
     * @param {Number=} _waitForAssignmentTimeout - optional. how long should we wait for conversation assignmet, overrides service <i>waitForAssignmentTimeout<i/> configuration
     */
    ringService.prototype.takeConversation = function (request, _waitForAssignmentTimeout) {
        var actualWaitForAssignmentTimeout = _.isNumber(_waitForAssignmentTimeout) ? _waitForAssignmentTimeout : waitForAssignmentTimeout;
        if (ringList.length > 0) {
            logger.debug('Take conversation called');
            var ring = ringList[0];
            if (ring && ring.convId) {
                logger.debug('Taking conversation: ' + ring.convId + ' ring: ' + ring.ringId);
                lpTag.WebAgent.amsConnectionController.amsClient.takeConversation({
                    ringId: ring.ringId,
                    success: successCallback, //request && request.success,
                    error: errorCallback,
                    context: this
                });

            }

        } else {
            logger.error('Take conversation called when there are no conversations to take');
            logger.graph({name: 'noConversationsToTakeError'});
        }

        function successCallback() {
            var ringId = ring && ring.ringId;
            var conversationId = ring && ring.convId;
            var consumerId = ring && ring.consumerId;
            logger.info('taking conversation: ' + conversationId + ' ring: ' + ringId);
            if (ringId) {
                _removeRingFromList(ringId, 'ringId');
                _updateCount();
            }

            var timerRef = setTimeout(function(){
                logger.error('Could not complete take conversation: ' + conversationId + ' ring: ' + ringId + ' - conversation data missing.');
                logger.graph({name: 'takeConversationErrorTimeout'});
                queueModel.unbind('chats.' + conversationId + '.agentInfo.messagingUserId', onAssignedAgentAvailable);
                var requestCallback = request && request.error;
                if (requestCallback) {
                    requestCallback.call(request.context, {
                        error: {
                            message: 'conversation data missing - timeout while waiting to data from subscription.'
                        }
                    });
                }

            }, actualWaitForAssignmentTimeout);

            // waiting for the chat model to get the update about the assigned agent.
            queueModel.bind('chats.' + conversationId + '.agentInfo.messagingUserId', onAssignedAgentAvailable);

            function onAssignedAgentAvailable(data) {
                if (data && data.newValue && data.newValue === queueModel.get('agent.messagingUserId')) {
                    clearTimeout(timerRef);
                    var requestCallback = request && request.success;
                    if (requestCallback) {
                        requestCallback.call(request.context, {conversationId: conversationId, consumerId: consumerId});
                    }
                    lpTag.WebAgent.amsController.createMyEngagementForConversation(ring.convId);
                    queueModel.unbind('chats.' + ring.convId + '.agentInfo.messagingUserId', onAssignedAgentAvailable);
                }
            }
        }

        function errorCallback(errorData) {
            var ringId = ring && ring.ringId;
            var conversationId = ring && ring.convId;
            logger.error('Could not take conversation: ' + conversationId + ' ring: ' + ringId);
            logger.graph({name: 'takeConversationError'});
            if (ringId) {
                _removeRingFromList(ringId, 'ringId');
                _updateCount();
            }
            var requestCallback = request && request.error;
            if (requestCallback) {
                requestCallback.call(request.context, errorData);
            }
        }
    };

    /**
     * Reject all the rings in the ringlist
     * @param request - The request, containing optional success/error/context
     */
    ringService.prototype.rejectAllRings = function () {
        logger.debug('Reject all rings called');
        // Clone the ringList so Loop go through it, while the rejectRing remove rings from the original list
        var ringListClone = lpUtils.cloneObject(ringList);
        for (var i= 0,max =ringListClone.length; i < max; i++) {
            _rejectRing(ringListClone[i]);
        }
    };
    /**
     * Called with an update to a ring (or adding a new ring). We use the ring to take the conversation.
     * We ignore rings if we have a working subscription.
     * @param ring - The ring. Should have the following structure: {
     *      "brandId" : "brand1",
     *      "consumerId" : "consumer1",
     *      "convId" : "conv1",
     *      "ringExpiration" : 60,
     *      "ringId" : "ringId1",
     *      "ringState" : "WAITING",
     *      "skillId" : "default_skill"
     * }
     */
    ringService.prototype.onRingUpdate = function (ring) {
        // If we're working with subscriptions - we ignore "old" ring updates
        if (!this.subscriptionId) {
            _handleRingUpdate(ring);
        }
    };

    /**
     * Called with new routing notifications. We only use them when we have a working subscription, and they belong
     * to that subscription.
     * @param routingNotification
     */
    ringService.prototype.onRoutingNotification = function(routingNotification) {
        // We only accept routing notifications from our subscription
        if (routingNotification && this.subscriptionId && routingNotification.changes && routingNotification.subscriptionId === this.subscriptionId) {
            for(var changeIndex = 0; changeIndex < routingNotification.changes.length; changeIndex++) {
                var change = routingNotification.changes[changeIndex];
                if (change && change.result && change.result.ringsDetails) {
                    // handling each change - update if it's an UPSERT, or remove if it's a DELETE
                    if (change.type === lpAMSController.NOTIFICATION_TYPES.UPSERT) {
                        _handleUpsertChange(change);
                    } else {
                        _handleDeleteChange(change);
                    }
                }
            }
        }
    };

    ringService.prototype.socketClose = function(data) {
        if(!data || data.newValue !== 'closed'){
            return;
        }
        _clearRingList();
        _updateCount();
        if (this.subscriptionId) {
            this.subscriptionId = null;
        }
    };

    ringService.prototype.socketConnected = function(data) {
        if (!data || data.newValue !== 'connected') {
            return;
        }
        queueModel.bind('agent.messagingUserId', subscribeToRouting, this);

        function subscribeToRouting(data) {
            var that = this;
            queueModel.unbind('agent.messagingUserId', subscribeToRouting);
            if (data && data.newValue) {
                lpTag.WebAgent.amsConnectionController.amsClient.subscribeToRouting({
                    brandId: queueModel.get('account'),
                    agentId: data.newValue,
                    success: subscribeToRoutingSuccess,
                    error: subscribeToRoutingError,
                    context: that
                });
            }

            function subscribeToRoutingSuccess(data) {
                if (data && data.subscriptionId) {
                    this.subscriptionId = data.subscriptionId;
                    logger.info('Subscribed to routing notifications successfully. Subscription ID: ' + this.subscriptionId);
                } else {
                    logger.error('Error subscribing to routing notifications - no subscription ID');
                    logger.graph({name: 'noRoutingSubscriptionIdError'});
                }
            }

            function subscribeToRoutingError(errorData) {
                logger.error('Error subscribing to routing notifications! Error data: ' + JSON.stringify(errorData));
                logger.graph({name: 'subscribeToRoutingError'});
                if (this.subscriptionId) {
                    this.subscriptionId = null;
                }
            }
        }
    };

    /**
     * Disposes of all the data and unbinds from the model
     */
    ringService.prototype.dispose = function () {
        _clearRingList();
    };


    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    /**
     * Handles an UPSERT change by updating all the specified rings
     * @param change - the Routing notification change.
     * @param change.type - The type of change. Should be UPSERT.
     * @param change.result - Contains the information regarding the change.
     * @param change.result.ringsDetails - Array of rings.
     * @private
     */
    function _handleUpsertChange(change) {
        for(var ringIndex = 0; ringIndex < change.result.ringsDetails.length; ringIndex++) {
            var ring = change.result.ringsDetails[ringIndex];
            if (ring) {
                _handleRingUpdate(ring);
            }
        }

    }

    /**
     * Handles a DELETE change by removing all the specified rings
     * @param change - the Routing notification change.
     * @param change.type - The type of change. Should be DELETE.
     * @param change.result - Contains the information regarding the change.
     * @param change.result.ringsDetails - Array of rings.
     * @private
     */
    function _handleDeleteChange(change) {
        for(var ringIndex = 0; ringIndex < change.result.ringsDetails.length; ringIndex++) {
            var ring = change.result.ringsDetails[ringIndex];
            if (ring) {
                _removeRingFromList(ring.ringId, 'ringId');
            }
        }
        _updateCount();
    }

    /**
     * Called with an update to a ring (or adding a new ring). We use the ring to take the conversation.
     * @param ring - The ring. Should have the following structure: {
     *      "brandId" : "brand1",
     *      "consumerId" : "consumer1",
     *      "convId" : "conv1",
     *      "ringExpiration" : 60,
     *      "ringId" : "ringId1",
     *      "ringState" : "WAITING",
     *      "skillId" : "default_skill"
     * }
     * @private
     */
    function _handleRingUpdate(ring) {
        if (ring) {
            logger.debug('Ring update received: ' + ring);
            _removeRingFromList(ring.convId);
            if (ring.ringState && ring.ringState === lpTag.AMSStatics.ringStates.WAITING) {
                _addRingToList(ring);
            }
            _updateCount();
        }
    }
    /**
     * Reject the ring
     * @param ring - The ring. (This function use only the ringId)
     */
    function _rejectRing(ring) {
        if (ring && ring.ringId) {
            _removeRingFromList(ring.convId);
            logger.debug('Reject ring: ' + ring.ringId);
            lpTag.WebAgent.amsConnectionController.amsClient.rejectRing({
                ringId: ring.ringId,
                success: successCallback, //request && request.success,
                error: errorCallback,
                context: this
            });
            _updateCount();
        } else {
            logger.error('Reject ring called when no ring');
            logger.graph({name: 'noRejectRingError'});
        }

        function successCallback() {
            var ringId = ring && ring.ringId;
            logger.info('Ring rejected: ' + ringId);
        }

        function errorCallback() {
            var ringId = ring && ring.ringId;
            logger.error('Could not reject the ring: ' + ringId);
            logger.graph({name: 'rejectRingError'});
        }
    }

    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            queueModel = model;
        }
    }

    /**
     * Adds a ring to the ring list
     * @param ring - The ring data
     * @private
     */
    function _addRingToList(ring) {
        ringList.push(ring);
    }

    /**
     * Removes a ring from the ring list, based on a given ID and property name
     * @param id - The ID to remove
     * @param name - The property name of the ID to search for within the ring list. Default is 'convId'.
     * @private
     */
    function _removeRingFromList(id, name) {
        var index = _getRingIndex(id, name || 'convId');
        if (index >= 0) {
            ringList.splice(index, 1);
        }
    }

    /**
     * Gets the index of the ring with the given ID within the open ring list
     * @param id - The ID of to look for in the list
     * @param property - The name of the ID to search for within the ring list.
     * @returns {number} - The index of the ring within the open ring list. -1 if not found.
     * @private
     */
    function _getRingIndex(id, property) {
        for (var index = 0; index < ringList.length; index++) {
            if (ringList[index] && ringList[index].hasOwnProperty(property) && ringList[index][property] === id) {
                return index;
            }
        }
        return -1;
    }

    /**
     * Updates the open conversation count in the model - based on the list
     * @private
     */
    function _updateCount() {
        queueModel.modify(lpAMSController.MODEL_PATHS.connectionsListModelLocations.openConversations, ringList.length);
    }

    function _clearRingList(){
        while (ringList.length > 0) {
            _removeRingFromList(ringList[0].convId);
        }
    }


    return ringService;

});
